module.exports = __webpack_public_path__ + "img/about-1-company.27c47abb.png";